/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Maxfeature31Inputs */

const zh_plan_maxfeature31 = /** @type {(inputs: Plan_Maxfeature31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专属客服支持`)
};

const en_plan_maxfeature31 = /** @type {(inputs: Plan_Maxfeature31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedicated support`)
};

const es_plan_maxfeature31 = /** @type {(inputs: Plan_Maxfeature31Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte dedicado`)
};

/**
* | output |
* | --- |
* | "Dedicated support" |
*
* @param {Plan_Maxfeature31Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_maxfeature31 = /** @type {((inputs?: Plan_Maxfeature31Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Maxfeature31Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_maxfeature31(inputs)
	if (locale === "en") return en_plan_maxfeature31(inputs)
	return es_plan_maxfeature31(inputs)
});
export { plan_maxfeature31 as "plan_maxFeature3" }